import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
import { dataSourceStatusLoadAction } from './DataSourceDetailStatus.ducks';
const actionTypesPrefix = 'loadTriggerDataSourceValidate';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const loadProfilingDataSourcesArgs = {
    actionPrefix: `${actionTypesPrefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (payload) => {
        return DataSourceResource.triggerValidate(payload.workspaceId, payload.dataSourceName);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
    afterActionsOnSuccess: (inputPayload) => {
        return [dataSourceStatusLoadAction(inputPayload.workspaceId, inputPayload.dataSourceName, '')];
    },
};
export const dataSourceValidateTriggerEpicReducer = loadResourcesUtils(loadProfilingDataSourcesArgs);
// Reducer
export const dataSourceValidateTriggerReducer = (state = defaultReducerState, action) => {
    state = dataSourceValidateTriggerEpicReducer.reduxChange(state, action);
    return state;
};
export default dataSourceValidateTriggerReducer;

//# sourceMappingURL=DataSourceValidate.ducks.js.map
